var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeTwoHours(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#fe4d01",
    xmlnsV: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.961 8.25L12 12 7 8.25h9.961z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 7.091V3.75a1.5 1.5 0 0 0-1.5-1.5H6.75a1.5 1.5 0 0 0-1.5 1.5v3.375c.001.233.055.462.159.67s.255.389.441.53L10.75 12l-4.9 3.675c-.186.14-.337.321-.441.529s-.159.438-.159.671v3.375a1.5 1.5 0 0 0 1.5 1.5h10.5a1.5 1.5 0 0 0 1.5-1.5v-3.341c0-.232-.055-.461-.158-.668s-.253-.389-.437-.529L13.244 12l4.911-3.712a1.51 1.51 0 0 0 .438-.529c.103-.208.157-.436.158-.668zm-12-3.341h10.5v3.341l-.541.409H7.25l-.5-.375V3.75zM12 11.063L9.25 9h5.475L12 11.063zm5.25 9.188H6.75v-3.375l4.5-3.375v2.25a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75v-2.242l4.5 3.401v3.341z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeTwoHours);
export default __webpack_public_path__ + "static/media/timeTwoHours.16aff405f8757a2845fb988fd82df49d.svg";
export { ForwardRef as ReactComponent };